import axios from "axios";
import React from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { useEffect } from "react";
import { baseUrl } from "../../../resources/Constants";
import logo from '../../../resources/img/logo-2.png';

const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
});

function NewUser() {

    const [client, setClient] = useState([]);
    const [mensaje, setMensaje] = useState('Para activar tu cuenta, haz clic en el enlace que hemos enviado a tu correo.');
    const [loading, setLoading] = useState(false);
    const [uid, setUid] = useState('');
    let userdata = [];

    let history = useHistory();


    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setUid(userdata.user_id);
        }

        //console.log('User email: '+userdata.email+' - User id: '+userdata.user_id);

    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);

        axiosInstance.get('/send-activation-link?uid=' + uid)
            .then(
                response => {
                    setLoading(false);
                    setMensaje(response.data.message);
                }
            )
            .catch(
                err => {
                    setLoading(false);
                }
            )
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="card card-outline card-primary login-card-style">
                    <div className="card-header text-center">
                        <img src={logo} style={{ width: '150px' }} />
                    </div>
                    <div className="card-body">
                        <p className="login-box-msg" style={{ color: '#067993', fontWeight: '700', fontSize: '1.3rem', fontWeight: '1.4rem' }}>{mensaje}</p>





                    </div>
                </div>
            </div>
        </div>
    );
}
export default NewUser;